// styles
import useStyles from "./styles";

// --| Widget Title takes title, subtitle and link as props, only usable in the dashboard component
const WidgetTitle = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.widgetTitleContainer}>
      <div className={classes.typo}>
        <h6 className={classes.title}>
          {props.title}
        </h6>
        {props.subtitle ? <h6 className={classes.subtitle}>{props.subtitle}</h6> : null}
      </div>
      {props.link ? <div className={classes.linkWrap}>{props.link}</div> : null}
    </div>
  );
};
export default WidgetTitle;
